module.exports = __webpack_public_path__ + "img/d.efb9536a.jpg";